import cn from 'classnames';
import { ClickableIcon, HStack, Label, Spinner, Text, TextCell, VStack } from '@direct-frontend/components';
import { type OpenApiSchemaIntegrationStatus } from '#shared/api/schema';
import { TemporalLogoSvg } from '#shared/assets';
import { ELLIPSIS, EMPTY_DASH } from '#shared/lib/constants';
import { openInNewTab } from '#shared/lib/router';
import { format } from '#shared/lib/string';
import { getTemporalIntegrationUrl } from '../../lib/getTemporalIntegrationUrl';
import styles from './IntegrationHistoryDateCell.module.css';

const DEFAULT_PROCESSING_TEXT = `В обработке${ELLIPSIS}`;

export const IntegrationHistoryDateCell = ({
    integration,
    processingText,
    className,
    isGrowable,
}: {
    integration: OpenApiSchemaIntegrationStatus;
    processingText?: string;
    className?: string;
    isGrowable?: boolean;
}) => {
    const temporalIntegrationUrl = getTemporalIntegrationUrl(integration);
    const temporalIntegrationIcon = temporalIntegrationUrl ? (
        <ClickableIcon
            onClick={() => openInNewTab(temporalIntegrationUrl)}
            role="supplementary"
            title="Открыть в Temporal"
            data-testid="temporal-icon"
        >
            <TemporalLogoSvg width={14} height={14} aria-hidden="true" focusable="false" />
        </ClickableIcon>
    ) : null;
    const resolvedProcessingText =
        processingText ?? (integration.status === 'in_progress' ? DEFAULT_PROCESSING_TEXT : undefined);
    const content = resolvedProcessingText ? (
        <Label
            size="3xs"
            addonLeft={<Spinner size="12" color="blue" />}
            addonRight={temporalIntegrationIcon || undefined}
            data-testid="processing-state"
        >
            {resolvedProcessingText}
        </Label>
    ) : (
        <VStack gap="4" data-testid="end-date-state">
            <HStack gap="6">
                <Text size="s">{integration.end_time ? format(integration.end_time, 'date') : EMPTY_DASH}</Text>
                {temporalIntegrationIcon}
            </HStack>
            {integration.end_time ? (
                <Text role="supplementary" size="xs">
                    {format(integration.end_time, 'time')}
                </Text>
            ) : null}
        </VStack>
    );

    return <TextCell className={cn(styles.root, className)} title={() => content} isGrowable={isGrowable} />;
};
